module.exports = __webpack_public_path__ + "img/one-lock.25a7cbc.svg";